import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from './store'

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: <TSelected>(selector: (state: RootState) => TSelected) => TSelected = useSelector;

export function delay(time: number) {
    return new Promise(resolve =>
      setTimeout(() => resolve(undefined), time)
    )
}

export function formatDates(startDate: Date, endDate: Date): string {
  const formatTime = (date: Date) => {
    const timeString = date.toTimeString();
    const timePart = timeString.split(' ')[0].substring(0, 5); // HH:MM
    const offsetMinutes = date.getTimezoneOffset();
    const offsetHours = Math.abs(offsetMinutes) / 60;
    const offsetSign = offsetMinutes <= 0 ? '+' : '-';
    const offsetString = `GMT${offsetSign}${Math.floor(offsetHours)}`;
    return `${timePart} ${offsetString}`;
  };
  return `${formatTime(startDate)} - ${formatTime(endDate)}`;
}